import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { MenuTreeResponse } from "@/types/interface/menu-tree";

export const useMenuTree = defineStore("menuTree", () => {
  const menus = ref<MenuTreeResponse[]>([]);

  function initMenus(data: any) {
    menus.value = data?.data;
  }

  async function dispatchGet(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuTree.getMenuTree(page, limit, queryParam);
      if (status === 200 ) {
        initMenus(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuTree.getMenuTreeAll(page, limit, queryParam);
      if (status === 200 ) {
        initMenus(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function getMenuByRole() : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuTree.getMenuRole();
      if (status === 200 ) {
        initMenus(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    menus,
    initMenus,
    dispatchGet,
    dispatchGetAll,
    getMenuByRole
  };
});